import { DateTime } from "luxon";

/**
 * Validates start/end datetimes for timesheet entry writes.
 * Accepts end after start and an explicit midnight reset (00:00 → 00:00 = 0h).
 * Skips range checks when either value is missing; pairing is validated elsewhere.
 */
export const isTimesheetEntryDatetimeRangeValid = (
  start_datetime?: string | null,
  end_datetime?: string | null,
): boolean => {
  if (!start_datetime || !end_datetime) {
    return true;
  }

  const start = DateTime.fromISO(start_datetime);
  const end = DateTime.fromISO(end_datetime);

  if (!start.isValid || !end.isValid) {
    return true;
  }

  if (start.equals(end) && start.hour === 0 && start.minute === 0) {
    return true;
  }

  return end > start;
};
